import React from 'react';
import {ActivityIndicator} from 'react-native';
import {useTheme} from 'styled-components/native';
import {OverlayModal} from '../../OverlayModal';
import {
  Container,
  LoadingContainer,
} from '../../../Interface/Loadings/Loading/styles';

interface SpinnerLoadingProps {
  visible?: boolean;
}

export function SpinnerLoading({visible = true}: SpinnerLoadingProps) {
  const theme = useTheme();

  return (
    <OverlayModal
      isVisible={visible}
      hasBackdrop={false}
      animationIn="fadeIn"
      animationOut="fadeOut"
      style={{margin: 0}}>
      <Container pointerEvents="auto">
        <LoadingContainer>
          <ActivityIndicator color={theme.colors.loading} />
        </LoadingContainer>
      </Container>
    </OverlayModal>
  );
}
